export const Theme = {
  colors: {
    "orange-100": "#E84E1B",
    "orange-300": "#761B0E",
    "gray-100": "#A3A3A3",
    "gray-300": "#3C3C3B",
    black: "#1D1D1B",
    bgColor: "#fff",
    borderColor: "#cbcbcb",
    textColor: "#8B9EB2",
    red: "#ED0000",
  },

  padding: {
    mobile: "2rem 1.25rem", //32px 20px
    primary: "7.5rem 1.25rem", //120px 20px
    second: "12.5rem 1.25rem", //70px 20px
  },

  screen: {
    sm: "40rem", //640px (Mobile),
    md: "48rem", //768px (Tablet)
    lg: "64rem", //1024px (Desktop)
    xl: "80rem", //1280px
    "2xl": "96rem", //1536px
    "3xl": "106rem", //1700px
    "4xl": "120rem", //1920px
  },

  margin: {
    titleMobile: "2rem", //32px
    title: "3rem", //48px
  },

  textSize: {
    title: "2rem", //32px
    titleMobile: "1.25rem", //20px
    subTitle: "1.5rem", //24px
    subTitleMobile: "1rem", //16px
    text: "1rem", //16px
  },
};
